"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.save = exports.fetch = void 0;
const t = require("io-ts");
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const sok_types_1 = require("@caddigital/sok-types");
const validation_1 = require("../../utils/validation");
const translation_1 = require("../../utils/translation");
const actionTypes = require("../../actionTypes/modelspace/customer");
const actions = require("../../actions/modelspace/customer");
function fetch(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.FETCH_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/modelspace/customer/${action.payload}/configuration`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(sok_types_1.Modelspace.iCustomerConfiguration)
            .decode(response);
        const act = validation.fold((err) => actions.fetchFailed((0, errorHandling_1.parseValidationError)(err)), (res) => actions.fetchSuccess(res));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.fetch = fetch;
const saveValidation = (configuration) => {
    const configurationId = parseInt(configuration.configurationId, 10);
    const customerId = parseInt(configuration.customerId, 10);
    let validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('configurationId')(configuration))((0, validation_1.isNotEmpty)('customerId')(configuration));
    if (!/^([0-9]+)$/.test(configuration.configurationId)) {
        validation = (0, validation_1.ap)(validation)(fp.validation.failure([
            {
                key: 'configurationId',
                value: (0, translation_1.getLocalization)('validation/error/valueMustBeNumber')
            }
        ]));
    }
    if (!/^([0-9]+)$/.test(configuration.customerId)) {
        validation = (0, validation_1.ap)(validation)(fp.validation.failure([
            {
                key: 'customerId',
                value: (0, translation_1.getLocalization)('validation/error/valueMustBeNumber')
            }
        ]));
    }
    return validation.map(() => ({
        customerId,
        configurationId
    }));
};
function save(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.ADD_REQUEST), (0, operators_1.switchMap)((action) => saveValidation(action.payload.configuration).fold((x) => (0, rxjs_1.of)(actions.validationFailed(x)), (configuration) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: configuration,
        url: `${baseUrl}api/modelspace/customer/${action.payload.customerId}/configuration`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(actions.addSuccess(), actions.fetchRequest(action.payload.customerId))), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.addFailed((0, errorHandling_1.parseAjaxErrorResponse)(err))))))));
}
exports.save = save;
function remove(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.REMOVE_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        body: action.payload.configuration,
        url: `${baseUrl}api/modelspace/customer/${action.payload.customerId}/configuration`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(actions.removeSuccess(), actions.fetchRequest(action.payload.customerId))), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.removeFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.remove = remove;
//# sourceMappingURL=customer.js.map